import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import useStyles from "./ControlGLReconciliation.styles";
import { SnowflakeProvider } from "../../../context/SnowflakeContext";
import ControlGLReconciliationFiltersAndReports from "../ControlGLReconciliation/ControlGLReconciliationFiltersAndReports.component";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const ControlGLReconciliation = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container spacing={2}>
        <SnowflakeProvider>
          <ControlGLReconciliationFiltersAndReports />
        </SnowflakeProvider>
        <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default ControlGLReconciliation;
